import { Button } from "@/shared/components/ui/button"
import { Trash2 } from "lucide-react"
import { useTranslation } from "react-i18next"

interface RemoveItemButtonProps {
  onRemove: () => void
}

export function RemoveItemButton({ onRemove }: RemoveItemButtonProps) {
  const { t } = useTranslation()

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={onRemove}
      className="absolute right-2 top-2 h-8 w-8 hover:bg-destructive/10 hover:text-destructive"
    >
      <Trash2 className="h-4 w-4" />
      <span className="sr-only">{t('agents.workflow.nodeConfig.mapping.removeItem')}</span>
    </Button>
  )
}
